/**
 * Felles klasser for Admin (#159, steg 9c, Stell_Admin).
 */
import { GLASS_SURFACE } from '../../components/primitives/Card';

/** Glasskortet, som «Oppgaver i dag» på Oppgavemaler: 14 px til siden. */
export const ADMIN_CARD = `${GLASS_SURFACE} rounded-lg px-3.5 py-3 shadow-md`;

/** Samme glass for radlista, der radene selv gir høyden. */
export const ADMIN_LIST = `${GLASS_SURFACE} rounded-lg px-3.5 py-0.5 shadow-md`;

/**
 * Raden i Admin-lista: etikett, verdi og pil. Delt av AdminDashboardPanel og
 * ForceReloadButton, som tegner sin egen rad.
 */
export const ADMIN_ROW = 'flex min-h-13 w-full items-center gap-2 text-left text-sm font-bold text-ink';

/** Seksjonsetiketten i versaler (skissenes `t.lbl`). */
export const ADMIN_LABEL = 'm-0 text-caption font-bold tracking-wider text-ink-2 uppercase';
